import React from "react";
import { connect } from "react-redux";
import { Input } from "antd";
import * as drivers from "../../modules/drivers";

class DriverQuotesSearch extends React.Component {
    componentWillUnmount() {
        this.props.clearSearchQuery();
    }

    onChange = e => {
        const query = e.target.value;
        this.props.updateSearchQuery(query.trim());
    };

    render() {
        return (
            <Input.Search
                defaultValue={this.props.searchQuery}
                placeholder="Search quotes..."
                onChange={this.onChange}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        searchQuery: state.drivers.searchQuery
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clearSearchQuery: () => dispatch(drivers.clearSearchQuery()),
        updateSearchQuery: query => dispatch(drivers.updateSearchQuery(query))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DriverQuotesSearch);



// WEBPACK FOOTER //
// ./src/components/Results/DriverQuotesSearch.js